import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';
import { IconContainerComponent } from '@enginuity/core/atoms/icon-container/icon-container.component';
import { ActionBtnComponent } from '../action-btn/action-btn.component';

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss'],
  imports: [
    CommonModule,
    NgOptimizedImage,
    CeIconComponent,
    IconContainerComponent,
    ActionBtnComponent,
  ],
})
export class FileComponent {
  @ViewChild('file') file: ElementRef | undefined;
  @Input() uploading: boolean = false;
  @Output() onChange = new EventEmitter<FileList | null>();
  @Output() change = new EventEmitter<any>();
  @Output() remove = new EventEmitter<any>();

  @Input() label: string = '';
  @Input() text: string = 'or drag & drop an file';
  @Input() sizeLabel: string = '';
  @Input() state: string = '';
  @Input() isMultiple: boolean = false;

  @Input() uploaded: any = {
    fileName: 'Customers_Q4_2023.csv',
    fileSize: '423kb',
    fileType: 'Drug license',
  };

  @Input() editImg(event: any) {}

  public dropOver = false;

  onDragOver(event: any) {
    event.preventDefault();
    this.dropOver = true;
  }

  onDragLeave(event: any) {
    event.preventDefault();
    this.dropOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.dropOver = false;
    this.change.emit(event);
    this.onChange.emit(event.dataTransfer?.files);
    this.file!.nativeElement!.value = '';
  }

  onFilesSelected(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.onChange.emit(inputElement?.files);
  }

  onInputClick($event: any) {
    // TODO: Just a placeholder
  }
}
